import {
  filterSubsectionsByName,
  findContentfulComponentByName,
} from 'components/PageSections/utils';

import { QuizProps } from './EmailQuiz';

export const parseQuizData = (contentfulSection: any): QuizProps | null => {
  const { subsections } = contentfulSection;

  const filteredQuestionComponents = filterSubsectionsByName(
    'EmailQuizQuestion',
    subsections,
  );
  const emailQuizCaptureComponent = findContentfulComponentByName(
    'EmailQuizCapture',
    subsections,
  );
  const filteredImageCalloutComponent = findContentfulComponentByName(
    'EmailQuizImageCallout',
    subsections,
  );

  const questions = filteredQuestionComponents!.map((item: any) => {
    const { subsections } = item;

    const options = subsections.map((option: any) => {
      let image = null;

      if (option.images) {
        image = {
          gatsbyImageData: option.images[0]?.desktopImage?.gatsbyImageData,
        };
      }

      return {
        title: option.displayName,
        image: image,
      };
    });

    return {
      title: item.metadata?.title,
      eyebrow: item.eyebrow,
      options: options,
      quizQuestionType: item.metadata?.context?.quizQuestionType,
    };
  });

  const hasQuizCaptureScreenCTA =
    emailQuizCaptureComponent?.metadata?.ctas?.[0];

  const quizEmailCapture = {
    title: emailQuizCaptureComponent!.metadata?.title || '',
    cta: hasQuizCaptureScreenCTA
      ? {
          label: emailQuizCaptureComponent!.metadata?.ctas?.[0]?.label || '',
          url: emailQuizCaptureComponent!.metadata?.ctas?.[0]?.url || '',
        }
      : undefined,
  };

  const rightSection =
    filteredImageCalloutComponent &&
    filteredImageCalloutComponent?.images?.length &&
    filteredImageCalloutComponent?.images[0]?.desktopImage?.gatsbyImageData
      ? {
          backgroundImage: {
            gatsbyImageData:
              filteredImageCalloutComponent.images[0].desktopImage
                .gatsbyImageData,
          },
          title: filteredImageCalloutComponent.metadata?.title || '',
          eyebrow: filteredImageCalloutComponent.eyebrow || '',
          cta: {
            label:
              filteredImageCalloutComponent.metadata?.ctas?.[0]?.label || '',
            url: filteredImageCalloutComponent.metadata?.ctas?.[0]?.url || '',
          },
        }
      : undefined;

  return {
    questions: questions,
    quizEmailCapture: quizEmailCapture,
    rightSection: rightSection,
  };
};
